import { defineMessages } from "react-intl";

import {
	validator,
	valueMessages
} from "lib/build/forms/ltx/phase-i/lab-procedures/standard-lab-procedures/coombsDirect";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	coombsDirect: {
		id: "form.coombs_direct",
		defaultMessage: "Coombs direkt"
	},
	value: {
		id: "form.coombs_direct.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: valueMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "coombsDirect",
	value: {
		title: messages.coombsDirect,
		validator,
		fieldset,
		isImportant: true
	}
};
